import styled from 'styled-components'

import { LockPinIcon } from '@root/shared/ui-kit'

type UpdatePasswordHeadingProps = {
  title: string
}

export const UpdatePasswordHeading: React.FC<UpdatePasswordHeadingProps> = ({
  title,
}) => (
  <Root>
    <Icon>
      <LockPinIcon size={38} />
    </Icon>
    <Title>{title}</Title>
  </Root>
)

const Root = styled.div`
  display: grid;
  justify-items: center;
  place-content: center;

  &::after {
    content: '';

    height: 1px;
    width: 100%;
    min-width: 300px;
    margin: 16px 0;

    opacity: 0.05;
    background: radial-gradient(
      50% 50% at 50% 50%,
      var(--text-12) 0%,
      var(--text-12) 80%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`

const Icon = styled.div`
  background: var(--backgroundA-4);
  border-radius: 100%;

  display: grid;

  width: 38px;
  height: 38px;
  flex-shrink: 0;
  place-content: center;
`

const Title = styled.div`
  color: var(--text-12);

  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;

  margin-top: 10px;
`
